import { toNumber } from 'lodash-es';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { org, updateOgInfo } from 'services/api/admin';
import { errorToasterWithServerMsg } from 'utils/errorToaster';

export type OrgValue = Oversea.Org & { orgId?: number; expiredInDays?: number };

function mergeOrgInfo(info: Oversea.Org): OrgValue {
  return {
    ...info,
    orgId: toNumber(info.id),
    expiredInDays: info.activeExpireDay,
  };
}

export const orgState = atom<OrgValue | undefined>();
orgState.onMount = (setAtom) => {
  org()
    .then(mergeOrgInfo)
    .then(setAtom)
    .catch((e) => {
      errorToasterWithServerMsg(e, '获取org信息失败，请稍后再试');
      return undefined;
    });
};

export const useOrgValue = () => useAtomValue(orgState);
export const useSetOrgValue = () => useSetAtom(orgState);

export const useOrgInfoRrefesher = () => {
  const setOrg = useSetOrgValue();
  return () => {
    org().then((org) => setOrg(mergeOrgInfo(org)));
  };
};

export const useOrgNameUpdater = () => {
  const refresher = useOrgInfoRrefesher();
  return async (name: string) => {
    await updateOgInfo({ name });
    refresher();
  };
};
